import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthPut1} from "../../../../../core/services/common/HttpRequestBuilder"


const countAccessLogs = (parameters) => {

    let result = HttpAuthGet(routes.COUNT_ACCESS_LOGS, parameters);
    return result;
}

const countGatepass = (parameters) => {

    let result = HttpAuthGet(routes.COUNT_GATEPASS, parameters);
    return result;
}

const countVehicle = (parameters) => {

    let result = HttpAuthGet(routes.COUNT_VEHICLE, parameters);
    return result;
}

const countBooking = (parameters) => {

    let result = HttpAuthGet(routes.COUNT_BOOKING, parameters);
    return result;
}

const countContainer = (parameters) => {

    let result = HttpAuthGet(routes.COUNT_CONTAINER, parameters);
    return result;
}

const getUserCount = (parameters) => {
    let result = HttpAuthGet(routes.COUNT_USER, parameters);
    return result;
}

const bookingAnalytics = (parameters) => {
    let result = HttpAuthGet(routes.BOOKING_ANALYTICS, parameters);
    return result;
}

const gatepassAnalytics = (parameters) => {
    let result = HttpAuthGet(routes.GATEPASS_ANALYTICS, parameters);
    return result;
}

const vehicleAnalytics = (parameters) => {
    let result = HttpAuthGet(routes.VEHICLE_ANALYTICS, parameters);
    return result;
}

const containerAnalytics = (parameters) => {
    let result = HttpAuthGet(routes.CONTAINER_ANALYTICS, parameters);
    return result;
}

const getOrgNameByOrgUID = (parameters) => {
    let result = HttpAuthPost(routes.GET_ORG_NAME_BY_ORGUID, parameters);
    return result;
}

const bookingNameByPurpose = (parameters) => {
    let result = HttpAuthPost(routes.BOOKING_NAME_BY_PURPOSE, parameters);
    return result;
}

const DashboardService = {
    countAccessLogs,
    countGatepass,
    countVehicle,
    countBooking,
    countContainer,
    getUserCount,
    bookingAnalytics,
    gatepassAnalytics,
    vehicleAnalytics,
    containerAnalytics,
    getOrgNameByOrgUID,
    bookingNameByPurpose
   
}

export default DashboardService
